/** 约量下单 S2 - 渠道端 */

export const buildWechatQrCodeUrl = function (ticket) {
  return `https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${ticket}`
}

export const getSupVolumeBindQRCode = function (params) {
  return this.$http('get', 'mall/wechatOpenApi/createSupVolumeBindQRCode', params)
}

export const submitQdVolume = function (params) {
  return this.$http('post', 'mall/supVolume/qd/submit', params)
}

export const getQdMyVolumeList = function (params) {
  return this.$http('get', 'mall/supVolume/qd/myList', params)
}

export const getQdVolumeDetail = function (params) {
  return this.$http('get', 'mall/supVolume/qd/detail', params)
}

export const getQdVolumeChangeLogPage = function (params) {
  return this.$http('get', 'mall/supVolume/qd/changeLogPage', params)
}

export const getQdVolumeProductList = function (params) {
  return this.$http('get', 'mall/supVolume/qd/productList', params)
}

/** 约量下单 S2 - 商务端 */

export const getBizChannelRecordPage = function (params) {
  return this.$http('get', 'mall/supVolume/biz/channelRecordPage', params)
}

export const createBizVolume = function (params) {
  return this.$http('post', 'mall/supVolume/biz/create', params)
}

export const updateBizVolume = function (params) {
  return this.$http('post', 'mall/supVolume/biz/update', params)
}

export const confirmBizComplete = function (params) {
  return this.$http('post', `mall/supVolume/biz/confirmComplete?id=${params.id}`, {})
}

export const getBizVolumeDetail = function (params) {
  return this.$http('get', 'mall/supVolume/biz/detail', params)
}

export const getBizVolumeChangeLogPage = function (params) {
  return this.$http('get', 'mall/supVolume/biz/changeLogPage', params)
}
